import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  date: string
  index: number
  type: string
}

const CardErrorEngine: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  date,
  children,
  index,
  type,
}) => {
  const { t } = useTranslation()
  return (
    <Box display='flex' justifyContent='center' sx={{ m: 1 }}>
      <Accordion sx={{ width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 }, background: 'gray' }}>
        <AccordionSummary
          aria-controls='panel1a-content'
          expandIcon={
            <ExpandMoreIcon sx={{ backgroundColor: 'red', borderRadius: '50%', color: '#fff' }} />
          }
          id='panel1a-header'
          sx={{
            '& .MuiAccordionSummary-content': {
              display: 'flex',
              justifyContent: 'space-between',
            },
          }}
        >
          <Box display='flex'>
            <Typography
              component={'span'}
              sx={{
                background: 'red',
                color: 'white',
                width: '25px',
                ml: '5px',
                textAlign: 'center',
                borderRadius: '7px',
              }}
            >
              {index}
            </Typography>
            <Typography
              component={'span'}
              sx={{ fontSize: { xs: '0.8rem', sm: '0.8rem', md: '1rem', lg: '1rem' } }}
            >
              {t('screens.HistoryErrorsScreen.error_code')}:{title}
            </Typography>
          </Box>
          <Typography
            component={'span'}
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.8rem', md: '1rem', lg: '1rem' },
              color: 'red',
              fontWeight: 'bold',
            }}
          >
            {t('screens.HistoryErrorsScreen.type_error')} :{type}
          </Typography>
          <Typography
            component={'span'}
            sx={{ fontSize: { xs: '0.8rem', sm: '0.8rem', md: '1rem', lg: '1rem' } }}
          >
            {date}
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ background: '#D6E4E5' }}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default CardErrorEngine
